<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>

      <feedback-form-box
        list-url="/feedback"
        :id="id"
        feedback-type="feedback"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
      ></feedback-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import FeedbackFormBox from '../../components/FeedbackFormBox.vue';

export default {
  name: 'FeedbackForm',
  components: {
    FeedbackFormBox
  },
  async mounted() {
    if (this.$route.name === 'feedback-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'feedback',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New Feedback' : 'Update Feedback';
    },
    ...mapState('feedback', ['loading'])
  },
  methods: {
    ...mapActions('feedback', ['getOne', 'postOne', 'patchOne']),
    onAdd({ feedback }) {
      this.postOne({
        feedback,
        router,
        redirectUrl: '/feedback'
      });
    },
    onEdit({ feedback }) {
      this.patchOne({
        type: 'feedback',
        id: this.id,
        feedback,
        router,
        redirectUrl: '/feedback'
      });
    }
  }
};
</script>
